import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_8: FaireProductEntity = {
  token: "nyc-bev-8",
  type: "product",
  name: "Craft Ginger Beer",
  brandName: "Spice Route Beverages",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8214621cb3ab970168b2f23ffad9c39b1dec1d42c8b2bb40239c1e7d7d77a7ae.webp",
  priceDollars: 9.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/8214621cb3ab970168b2f23ffad9c39b1dec1d42c8b2bb40239c1e7d7d77a7ae.webp",
  weight: 1.3,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  description: "Spicy ginger beer from Brooklyn",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "spicy", "brooklyn"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
